export type ContentSection = {
  heading: string;
  paragraphs: string[];
};

export default function ArticleBody({ sections }: { sections: ContentSection[] }) {
  return (
    <div className="flex flex-col gap-8">
      {sections.map((section, index) => (
        <section
          key={section.heading}
          id={`section-${index}`}
          className="scroll-mt-24 flex flex-col gap-3"
        >
          <h2 className="font-heading text-xl font-semibold text-foreground-950">
            {section.heading}
          </h2>
          {section.paragraphs.map((paragraph, pIdx) => (
            <p
              key={`${section.heading}-${pIdx}`}
              className="text-sm md:text-base leading-relaxed text-foreground-700"
            >
              {paragraph}
            </p>
          ))}
        </section>
      ))}
    </div>
  );
}